/** Standard SCM staleness disclaimer — UI + DOCX exports. */
export const SCM_DATA_DISCLAIMER =
  'Directory pricing, lead times, and availability are indicative and may be outdated. '
  + 'Confirm all commercial terms directly with the supplier before procurement decisions.';

export const SCM_DATA_DISCLAIMER_SHORT =
  'Indicative data only — confirm with supplier before decisions.';

/** Days after which directory data should show a verify prompt. */
export const SCM_STALE_DATA_DAYS = 90;

export function isSupplierDataStale(
  freshness: { lastUpdatedAt: string } | undefined,
  now: Date = new Date(),
): boolean {
  if (!freshness?.lastUpdatedAt) return false;
  const t = new Date(freshness.lastUpdatedAt).getTime();
  if (Number.isNaN(t)) return false;
  const ageMs = now.getTime() - t;
  return ageMs > SCM_STALE_DATA_DAYS * 24 * 60 * 60 * 1000;
}
